'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$LocalShodoCertChainResponse(hash, chain) {
  this.Xb = null;
  this.Xa = null;
  this.Xb = hash;
  this.Xa = chain;
}
export { $c_Lpresto_AgentView$LocalShodoCertChainResponse as $c_Lpresto_AgentView$LocalShodoCertChainResponse };
$p = $c_Lpresto_AgentView$LocalShodoCertChainResponse.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$LocalShodoCertChainResponse;
/** @constructor */
function $h_Lpresto_AgentView$LocalShodoCertChainResponse() {
}
export { $h_Lpresto_AgentView$LocalShodoCertChainResponse as $h_Lpresto_AgentView$LocalShodoCertChainResponse };
$h_Lpresto_AgentView$LocalShodoCertChainResponse.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lpresto_AgentView$LocalShodoCertChainResponse) && ((this.Xb === x$0.Xb) && (this.Xa === x$0.Xa))));
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "LocalShodoCertChainResponse";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Xb;
  }
  if ((n === 1)) {
    return this.Xa;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_AgentView$LocalShodoCertChainResponse(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hJ)));
}
export { $isArrayOf_Lpresto_AgentView$LocalShodoCertChainResponse as $isArrayOf_Lpresto_AgentView$LocalShodoCertChainResponse };
var $d_Lpresto_AgentView$LocalShodoCertChainResponse = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$LocalShodoCertChainResponse, "presto.AgentView$LocalShodoCertChainResponse", ({
  hJ: 1,
  bv: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AgentView$LocalShodoCertChainResponse as $d_Lpresto_AgentView$LocalShodoCertChainResponse };
//# sourceMappingURL=presto.-Agent-View$-Local-Shodo-Cert-Chain-Response.js.map
